export default "__VITE_ASSET__DnmAgasV__"